import React, { useState } from 'react';
import { useToggle } from 'react-use';
import classNames from 'classnames';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { api } from '~/api';
import { Button } from 'Components/nui';
import { FormattedMessage, useIntl } from 'react-intl';
import { ConfirmDialog } from '@/components/ui/confirm-dialog';
import ActionList from 'Components/ActionList';
import { useInvalidateMarketOrders } from '~/pages/Market/hooks/useMarketOrders';
import { tagMarketplaceTradingActivity } from '~/sentryMarketplace';

interface OwnerButtonsProps {
  order: any;
}

export default ({ order }: OwnerButtonsProps) => {
  const { formatMessage } = useIntl();
  const history = useHistory();
  const { pathname } = useLocation();

  const invalidateMarketOrders = useInvalidateMarketOrders();

  const [deleting, setDeleting] = useState(false);
  const [on, toggle] = useToggle(false);

  const deleteOrder = async () => {
    setDeleting(true);
    await api.getData(
      {
        type: 'orders',
        id: order.id,
      },
      null,
      { method: 'delete' }
    );

    tagMarketplaceTradingActivity('order_cancelled', {
      order_id: order.id,
      order_type: order.type,
    });

    toast.success(
      formatMessage({
        id: 'order-was-cancelled',
        defaultMessage: 'The order was cancelled',
      })
    );

    invalidateMarketOrders();
    history.replace(pathname);
    toggle(false);
  };

  return (
    <>
      <ActionList.Item>
        <Link
          to={`/orders/${order.pid}/edit`}
          className={classNames('button', order.type, 'small')}
        >
          <FormattedMessage
            id="marketrow-button-edit"
            defaultMessage="Edit"
            values={{ orderType: order.type }}
          />
        </Link>
      </ActionList.Item>
      <ActionList.Item>
        <Button type="simple" size="small" onClick={toggle}>
          <FormattedMessage
            id="marketrow-counters-button-delete"
            description="button for counters 'Delete' in Marketrow"
            defaultMessage="Delete"
          />
        </Button>
      </ActionList.Item>

      <ConfirmDialog
        open={on}
        onOpenChange={toggle}
        title={
          <FormattedMessage
            id="marketrow-deletemodal-header"
            defaultMessage="Warning"
          />
        }
        confirmLabel={
          <FormattedMessage
            id="vieworder-delete-order"
            defaultMessage="Delete order"
          />
        }
        cancelLabel={
          <FormattedMessage
            id="marketrow-deletemodal-button-no"
            defaultMessage="Go back"
          />
        }
        onConfirm={deleteOrder}
        isLoading={deleting}
      >
        <FormattedMessage
          id="marketrow-deletemodal-helptext"
          defaultMessage="Are you sure you want to delete the order? You can't undo this operation."
        />
      </ConfirmDialog>
    </>
  );
};
